import { List } from '../constants-types/PiList.model';
import { Job } from '../core-data-model/Job.model';
import { JobAssessment } from '../core-data-model/JobAssessment.model';
import { Pattern } from '../core-data-model/Pattern.model';
import { Person } from '../core-data-model/Person.model';
import { ResultSet } from '../core-data-model/ResultSet';
import { SearchResult } from '../core-data-model/SearchResult.model';

export class SearchResultSet extends ResultSet<SearchResult> {
    /* note that for this class you have to explicitly
    set any variables on construction otherwise when you
    generate a new version due to a mutation you may end
    up keeping hyour old values because of the behavior of
    the constructor of the base immutable list */
    _resultSetPersonWithPatternCount: number | 'notset' = 'notset';
    _resultSetHasPerson: boolean | 'notset' = 'notset';
    _resultSetJobWithTargetCount: number | 'notset' = 'notset';
    _resultSetHasJob: boolean | 'notset' = 'notset';

    constructor(results?: Iterable<SearchResult>) {
        super(results);
    }

    // figuring this as slight performance improvement
    // note that this is a dangerous technique and should be removed at the
    // first hint of problems
    get resultSetPersonWithPatternCount(): number {
        if (this._resultSetPersonWithPatternCount === 'notset') {
            this.figureHasPerson();
        }
        return this._resultSetPersonWithPatternCount as number;
    }

    get resultSetHasPerson(): boolean {
        if (this._resultSetHasPerson === 'notset') {
            this.figureHasPerson();
        }
        return this._resultSetHasPerson as boolean;
    }
    get resultSetJobWithTargetCount(): number {
        if (this._resultSetJobWithTargetCount === 'notset') {
            this.figureHasJob();
        }
        return this._resultSetJobWithTargetCount as number;
    }

    get resultSetHasJob(): boolean {
        if (this._resultSetHasJob === 'notset') {
            this.figureHasJob();
        }
        return this._resultSetHasJob as boolean;
    }

    private figureHasPerson(): void {
        const people = this.filter(
            (result): result is Person => result instanceof Person
        );
        this._resultSetHasPerson = !!people.size;
        this._resultSetPersonWithPatternCount =
            this.resultSetHasPerson &&
            people.filter((result) => result.hasBehavioralPattern()).size;
    }
    private figureHasJob(): void {
        const jobs = this.filter(
            (result): result is Job => result instanceof Job
        );
        this._resultSetHasJob = !!jobs.size;
        this._resultSetJobWithTargetCount =
            this.resultSetHasJob &&
            jobs.filter((result) => result.hasBehavioralJobTarget).size;
    }

    /*
    So I am including these two functions in here, These are used in
    MultipleContributorReviewPage and are calculated properties from the
    ResultSet. If in the futuren there is a lot of special
    purpose code in here we can start subclassing it.
    */
    private _scaledScores: {
        score: number;
        scaledScore: number;
    }[] = undefined;
    get scaledScores(): {
        score: number;
        scaledScore: number;
    }[] {
        if (!this._scaledScores) {
            this._scaledScores = this.filter(
                (r): r is JobAssessment => r instanceof JobAssessment
            )
                .filter((searchResult) => !searchResult.isPendingOrExpired())
                .filter((searchResult) => searchResult.cognitiveScore > 0)
                .map((searchResult) => ({
                    score: searchResult.cognitiveScore,
                    scaledScore: searchResult.cognitiveScaledScore
                }))
                .toArray();
        }
        return this._scaledScores;
    }

    private _selectedPatterns: List<Pattern> = undefined;
    get selectedPatterns(): List<Pattern> {
        if (!this._selectedPatterns) {
            this._selectedPatterns = this.filter(
                (searchResult): searchResult is JobAssessment | Person =>
                    (searchResult instanceof JobAssessment &&
                        !searchResult.isPendingOrExpired()) ||
                    (searchResult instanceof Person &&
                        searchResult.hasBehavioralPattern())
            ).map((searchResult: JobAssessment | Person) => {
                if (searchResult instanceof JobAssessment) {
                    return searchResult.behavioralPattern;
                } else if (searchResult instanceof Person) {
                    return searchResult.originalAssessment.pattern.self;
                }
            });
        }
        return this._selectedPatterns;
    }
}
